import { jsx as _jsx } from "react/jsx-runtime";
import { Autocomplete } from '@emburse/embark-core';
import { Employee, GetEmployeeOptions } from '../../interfaces/Employee';
import { getEmployees } from '../../api/employee';
import { $t, useTranslation } from '../../hooks/useTranslation';
function EmployeeSearch({ value, onSelect = () => { }, style, className, label, helperText, disabled, multiple, multipleType, getOptionLabel, error, id, defaultValue, disableClearable, exclusionList = [], onBlurWithValue = null, ...props }) {
    useTranslation();
    let lastKeyword;
    let lastValues = [];
    let defaultValues = [];
    let gotDefaultValues = false;
    const filterOutExclusions = (employees) => {
        return employees.filter((employee) => !exclusionList.includes(employee.PK));
    };
    const getMatchingEmployees = async (keyword) => {
        // empty keyword and there is no value in field
        if (!keyword && value === null) {
            if (!gotDefaultValues) {
                defaultValues = await getEmployees(new GetEmployeeOptions({ search: '', empTypes: props.empTypes || [] })).then(({ Results }) => Results);
                gotDefaultValues = true;
            }
            if (props.userId) {
                return defaultValues.filter((emp) => emp.UsrPK !== props.userId);
            }
            return defaultValues;
        }
        // there is a value in the field. Return selected option as the only option
        if (value !== null) {
            return [new Employee(value)];
        }
        if (keyword === lastKeyword) {
            return lastValues;
        }
        const results = await getEmployees(new GetEmployeeOptions({ search: keyword, empTypes: props.empTypes || [] })).then(({ Results }) => Results);
        if (props.userId) {
            lastValues = results.filter((emp) => emp.UsrPK !== props.userId);
        }
        else {
            lastValues = results;
        }
        lastKeyword = keyword;
        if (props.userId) {
            return results.filter((emp) => emp.UsrPK !== props.userId);
        }
        return results;
    };
    const asyncFetch = async (keyword) => {
        const matchingEmployees = await getMatchingEmployees(keyword);
        return filterOutExclusions(matchingEmployees);
    };
    const changeHandler = (e, employeeValue, reason) => {
        onSelect(employeeValue, reason);
    };
    const optionLabel = (option) => option.FullName?.length ? `${option.FullName} (${option.Email})` : '';
    return (_jsx(Autocomplete, { style: style, className: className || '', label: label || $t('Employee Search'), helperText: helperText, error: error, id: id || 'EmployeeSearch', disabled: disabled, value: value, defaultValue: defaultValue, multiple: multiple, multipleType: multipleType, getOptionLabel: getOptionLabel || optionLabel, disableClearable: disableClearable, onChange: changeHandler, useVirtualization: true, isAsync: true, asyncFetch: asyncFetch, asyncOnChangeTimeout: 500, onBlur: (event) => {
            if (onBlurWithValue) {
                onBlurWithValue(event, value);
            }
            else if (props.onBlur) {
                props.onBlur(event);
            }
        }, ...props }));
}
export default EmployeeSearch;
